// extracted by extract-css-chunks-webpack-plugin
module.exports = {"text":"text-3w2e3DBc"};